import React from 'react';
import MainLayout from './components/layout/MainLayout';
import LoadingOverlay from './components/common/LoadingOverlay';
import MessageSnackbar from './components/common/MessageSnackbar';
import UploadStep from './components/steps/UploadStep';
import ProcessingStep from './components/steps/ProcessingStep';
import EditStep from './components/steps/EditStep';
import GenerateStep from './components/steps/GenerateStep';
import { useAlbum } from './contexts/AlbumContext';

function App() {
  const { step } = useAlbum();

  const renderStep = () => {
    switch (step) {
      case 1:
        return <UploadStep />;
      case 2:
        return <ProcessingStep />;
      case 3:
        return <EditStep />;
      case 4:
        return <GenerateStep />;
      default:
        return <UploadStep />;
    }
  };

  return (
    <>
      <MainLayout>
        {renderStep()}
      </MainLayout>
      <LoadingOverlay />
      <MessageSnackbar />
    </>
  );
}

export default App;
